app.controller('ResourceCtrl', function ($rootScope, $scope, ResourceService, $window, $timeout, BASE_URL, IMAGE_SERVER_BASE_URL) {

    var self = this;

    self.show = function (resource, searchProfileId) {
        ResourceService.show(searchProfileId, resource.uri);
    };

    self.showDetails = function (resource) {

        if ($scope.searchData.masonryMode) $rootScope.modalActive = true;

        // hide others expanded resources
        for (var i = 0; i < $scope.resources.length; i++) {
            $scope.resources[i].expanded = false;
            if ($scope.resources[i].subResources) {
                for (var j = 0; j < $scope.resources[i].subResources.length; j++) {
                    $scope.resources[i].subResources[j].expanded = false;
                    if ($scope.resources[i].subResources[j].subResources) {
                        for (var k = 0; k < $scope.resources[i].subResources[j].subResources.length; k++) {
                            $scope.resources[i].subResources[j].subResources[k].expanded = false;
                        }
                    }
                }
            }
        }
        $scope.loadingDetails = true;

        // on defined mode we don't have concepts so we send and empty element
        if (typeof $scope.concepts === 'undefined') $scope.concepts = {flatList: []};

        ResourceService.showDetails($scope.searchData.searchProfileId, resource.uri, $scope.searchData.refineConcepts, $scope.concepts.flatList).then(function (resourceDetail) {
            $scope.loadingDetails = false;
            $scope.resourceDetail = resourceDetail;

            // track Piwik Analytics Goal 4 : Show Details
            if (window._paq) window._paq.push(['trackGoal', 4]);
        });

    };

    self.switchModeAndShowDetails = function (resource, index) {
        $scope.searchData.masonryMode = false;
        var target = angular.element('#resource-' + index).children()[0];
        // we wait a little bit to build the DOM and get offset
        $timeout(function () {
            angular.element("body").animate({scrollTop: target.getBoundingClientRect().top - 100}, "slow");
        }, 400);

    };

    self.shareByMail = function (resource) {

        var link = encodeURIComponent(BASE_URL
            + '/?mode=defined'
            + '&uri=' + encodeURIComponent(resource.uri)
            + '&searchProfileId=' + $scope.searchData.searchProfileId);

        // track Piwik Analytics Goal 6 : Share by email
        if (window._paq) window._paq.push(['trackGoal', 6]);

        $window.open('mailto:?body=' + link, '_self');
    };

    // set relevant tags after getting facet and resource promises
    if (typeof $scope.flatConceptList !== 'undefined') {
        for (var i = 0; i < $scope.resources.length; i++) {
            for (var j = 0; j < $scope.resources[i].subResources.length; j++) {
                for (var k = 0; k < $scope.resources[i].subResources[j].subResources.length; k++) {
                    // third level
                    for (var l = 0; l < $scope.resources[i].subResources[j].subResources[k].tags.length; l++) {
                        for (var m = 0; m < $scope.flatConceptList.length; m++) {
                            if ($scope.resources[i].subResources[j].subResources[k].tags[l].uri === $scope.flatConceptList[m].uri) {
                                $scope.resources[i].subResources[j].subResources[k].tags[l].isRelevant = true;
                                break;
                            }
                        }
                    }
                }

                // second level
                for (var l = 0; l < $scope.resources[i].subResources[j].tags.length; l++) {
                    for (var m = 0; m < $scope.flatConceptList.length; m++) {
                        if ($scope.resources[i].subResources[j].tags[l].uri === $scope.flatConceptList[m].uri) {
                            $scope.resources[i].subResources[j].tags[l].isRelevant = true;
                            break;
                        }
                    }
                }
            }

            // first level
            for (var j = 0; j < $scope.resources[i].tags.length; j++) {
                for (var k = 0; k < $scope.flatConceptList.length; k++) {
                    if ($scope.resources[i].tags[j].uri === $scope.flatConceptList[k].uri) {
                        $scope.resources[i].tags[j].isRelevant = true;
                        break;
                    }
                }
            }

        }
    }

    self.getThumbnail = function (resource, size) {

        if (resource.nature !== 'Photo') {
            return './dist/images/no-picture-available.png';
        }

        // Default size is 300px
        size = typeof size !== 'undefined' ? size : 300;

        // we extract resourceId from uri
        var resourceId = resource.uri.substr(resource.uri.indexOf("photos") + 7);

        return IMAGE_SERVER_BASE_URL + size + '/' + resourceId + '.jpg';
    };

    // navigate from one resource to another in Masonry mode
    self.goToResource = function (resourceIndex) {
        $scope.resources[resourceIndex].showDetailModal = true;
    };

    self.closeModal = function (resource) {
        resource.showDetailModal = false;
        $rootScope.modalActive = false;
    };

});
